import React, { useEffect, useState } from 'react';
import { fetchNotifications } from '../../../requests/notifications';
import { NotificationList } from '../../../app/common/sharedComponents/NotificationList';
import { HeaderContainer, NoNotificationContent } from './styled.notifications';
import { StyledMyAuditViewContainer } from '../MyAudit/MyAuditView/styled.MyAuditView';
import { showErrorMessage } from '../../../helpers/showMessage';
import { NotificationSkeleton } from './NotificationSkeleton';
import { Headline2 } from '../../../app/common/typography';
import {
  INotification,
  INotificationParams,
} from '../../../app/@types/notification';
import { useTranslation } from 'react-i18next';
import { sentryReport } from '../../../helpers/sentry';
import { AppHeader } from '../../../app/common/sharedComponents/AppHeader';
import { useNotificationRequest } from '../../../app/common/hooks/useNotificationRequest';

export const Notifications = () => {
  const [notificationsData, setNotificationsData] = useState<INotification[]>();
  const { t } = useTranslation();
  const notificationParam: INotificationParams = {
    page: 1,
    pageSize: 10,
    sort: '-id',
  };
  const {
    notificationParams,
    hasMoreNotifications,
    setHasMoreNotifications,
    fetchNextNotificationData,
  } = useNotificationRequest(setNotificationsData, notificationParam);

  useEffect(() => {
    fetchNotifications(notificationParams)
      .then((response) => {
        setNotificationsData(response.data.results);
        setHasMoreNotifications(
          notificationParams.page < response.data.numberOfPages
        );
      })
      .catch((error) => {
        showErrorMessage(
          t('COMMON.ALERT_MESSAGES.UNABLE_TO_GET_NOTIFICATIONS')
        );
        sentryReport(error.response.data, error.message, error.code, {
          summaryError: t('COMMON.ALERT_MESSAGES.UNABLE_TO_GET_NOTIFICATIONS'),
          path: '/notification',
        });
      });
  }, []);

  return (
    <>
      <HeaderContainer>
        <AppHeader
          title={t('COMMON.NOTIFICATION.TITLE')}
          hasBackButton={false}
        />
      </HeaderContainer>
      <StyledMyAuditViewContainer>
        {!notificationsData ? (
          <NotificationSkeleton />
        ) : notificationsData.length ? (
          <NotificationList
            NotificationData={notificationsData}
            fetchNextNotificationData={fetchNextNotificationData}
            hasMoreNotifications={hasMoreNotifications}
          />
        ) : (
          <NoNotificationContent>
            <Headline2>{t('COMMON.NOTIFICATION.GREAT_CONTENT')}</Headline2>
            <Headline2>{t('COMMON.NOTIFICATION.COMING_SOON')}</Headline2>
          </NoNotificationContent>
        )}
      </StyledMyAuditViewContainer>
    </>
  );
};
